export default {
  '***': {
    '***': [
      {
        "id": 10,
        "label": "Connectivity",
        "selected": 0,
        "collapse": 0,
        "parent": 0,
        "children": [
          21,
          22,
          23,
          24,
          25
        ],
        "tooltip": "This will be checked automatically when any item in this section is checked."
      },
      {
        "id": 11,
        "label": "Phone",
        "selected": 0,
        "collapse": 0,
        "parent": 0,
        "children": [
          26,
          27,
          28,
          29
        ],
        "tooltip": "This will be checked automatically when any item in this section is checked."
      },
      {
        "id": 12,
        "label": "Mobile",
        "selected": 0,
        "collapse": 0,
        "parent": 0,
        "children": [
          30,
          31,
          32
        ],
        "tooltip": "This will be checked automatically when any item in this section is checked."
      },
      {
        "id": 13,
        "label": "Security",
        "selected": 0,
        "collapse": 0,
        "parent": 0,
        "children": [
          33,
          34,
          35,
          36
        ],
        "tooltip": "This will be checked automatically when any item in this section is checked."
      },
      {
        "id": 14,
        "label": "TV",
        "selected": 0,
        "collapse": 0,
        "parent": 0,
        "children": [
          37,
          38
        ],
        "tooltip": "This will be checked automatically when any item in this section is checked."
      },
      {
        "id": 15,
        "label": "Other Comms Products",
        "selected": 0,
        "collapse": 0,
        "parent": 0,
        "children": [
          39,
          40,
          41,
          42,
          43,
          44,
          45
        ],
        "tooltip": "This will be checked automatically when any item in this section is checked."
      },
      {
        "id": 16,
        "label": "Miscellaneous Products",
        "selected": 0,
        "collapse": 0,
        "parent": 0,
        "children": [
          46,
          47,
          48,
          49,
          50,
          51,
          52,
          53
        ],
        "tooltip": "This will be checked automatically when any item in this section is checked."
      },
      {
        "id": 17,
        "label": "Brand",
        "selected": 0,
        "collapse": 0,
        "parent": 0,
        "children": [
          54,
          55,
          56,
          57,
          58,
          59
        ],
        "tooltip": "This will be checked automatically when any item in this section is checked."
      },
      {
        "id": 18,
        "label": "Acquisition",
        "selected": 0,
        "collapse": 0,
        "parent": 0,
        "children": [
          60,
          61,
          62,
          63,
          64,
          65,
          66
        ],
        "tooltip": "This will be checked automatically when any item in this section is checked."
      },
      {
        "id": 19,
        "label": "Creative Type",
        "selected": 0,
        "collapse": 0,
        "parent": 0,
        "children": [
          67,
          68,
          69,
          70,
          71
        ],
        "tooltip": "This will be checked automatically when any item in this section is checked."
      },
      {
        "id": 20,
        "label": "Creative Style",
        "selected": 0,
        "collapse": 0,
        "parent": 0,
        "children": [
          72,
          73,
          74,
          75,
          76,
          77,
          78,
          79
        ],
        "tooltip": "This will be checked automatically when any item in this section is checked."
      },
      {
        "id": 21,
        "label": "High Speed Internet",
        "selected": 0,
        "collapse": 0,
        "parent": 10,
        "children": [],
        "tooltip": "Fast broadband connectivity that enables businesses to run online applications, video conferencing, and cloud services smoothly."
      },
      {
        "id": 22,
        "label": "Internet Backup",
        "selected": 0,
        "collapse": 0,
        "parent": 10,
        "children": [],
        "tooltip": "A secondary internet connection that automatically activates during outages to maintain business continuity."
      },
      {
        "id": 23,
        "label": "Ethernet/Fiber",
        "selected": 0,
        "collapse": 0,
        "parent": 10,
        "children": [],
        "tooltip": "High capacity wired internet connections delivering reliable, low latency data transmission."
      },
      {
        "id": 24,
        "label": "WiFi",
        "selected": 0,
        "collapse": 0,
        "parent": 10,
        "children": [],
        "tooltip": "A wireless network that allows employees and customers to connect devices to the internet."
      },
      {
        "id": 25,
        "label": "Gigabit",
        "selected": 0,
        "collapse": 0,
        "parent": 10,
        "children": [],
        "tooltip": "Ultra fast internet service delivering speeds up to one gigabit per second and higher."
      },
      {
        "id": 26,
        "label": "Voicemail Services",
        "selected": 0,
        "collapse": 0,
        "parent": 11,
        "children": [],
        "tooltip": "A digital system that records and stores voice messages when calls cannot be answered."
      },
      {
        "id": 27,
        "label": "VoIP (Voice Over Internet Protocol)",
        "selected": 0,
        "collapse": 0,
        "parent": 11,
        "children": [],
        "tooltip": "A phone service that uses the internet to make and receive voice calls."
      },
      {
        "id": 28,
        "label": "Text Messaging",
        "selected": 0,
        "collapse": 0,
        "parent": 11,
        "children": [],
        "tooltip": "A communication service enabling businesses to send SMS messages to customers or employees."
      },
      {
        "id": 29,
        "label": "Virtual Conferencing / Meeting",
        "selected": 0,
        "collapse": 0,
        "parent": 11,
        "children": [],
        "tooltip": "Online meeting platforms that support video, audio, and screen sharing collaboration."
      },
      {
        "id": 30,
        "label": "5G",
        "selected": 0,
        "collapse": 0,
        "parent": 12,
        "children": [],
        "tooltip": "The latest wireless technology offering ultra fast speeds, low latency, and improved capacity for mobile devices."
      },
      {
        "id": 31,
        "label": "WiFi Hotspots",
        "selected": 0,
        "collapse": 0,
        "parent": 12,
        "children": [],
        "tooltip": "Designated locations that provide public or private wireless internet access."
      },
      {
        "id": 32,
        "label": "Business Wireless",
        "selected": 0,
        "collapse": 0,
        "parent": 12,
        "children": [],
        "tooltip": "Mobile plans and devices designed specifically for workplace connectivity and productivity."
      },
      {
        "id": 33,
        "label": "Network Monitoring / Security",
        "selected": 0,
        "collapse": 0,
        "parent": 13,
        "children": [],
        "tooltip": "Real time tracking and protection of network activity to detect threats and maintain performance."
      },
      {
        "id": 34,
        "label": "DDOS",
        "selected": 0,
        "collapse": 0,
        "parent": 13,
        "children": [],
        "tooltip": "Protection against Distributed Denial of Service attacks that overload and shut down networks."
      },
      {
        "id": 35,
        "label": "Enterprise Level Security",
        "selected": 0,
        "collapse": 0,
        "parent": 13,
        "children": [],
        "tooltip": "Advanced cybersecurity tools designed to safeguard large organizations' data and systems."
      },
      {
        "id": 36,
        "label": "Internet Security / Firewall Protection / DNS",
        "selected": 0,
        "collapse": 0,
        "parent": 13,
        "children": [],
        "tooltip": "Systems that block unauthorized access and protect devices and networks from online threats."
      },
      {
        "id": 37,
        "label": "Sports Packages (e.g. NFL Ticket)",
        "selected": 0,
        "collapse": 0,
        "parent": 14,
        "children": [],
        "tooltip": "Premium add on TV content offering access to live sporting events and specialty leagues."
      },
      {
        "id": 38,
        "label": "Streaming",
        "selected": 0,
        "collapse": 0,
        "parent": 14,
        "children": [],
        "tooltip": "Digital delivery of media\u2014such as video or music\u2014via the internet in real time."
      },
      {
        "id": 39,
        "label": "Inventory Management",
        "selected": 0,
        "collapse": 0,
        "parent": 15,
        "children": [],
        "tooltip": "Software that tracks products, supplies, and stock levels across a business."
      },
      {
        "id": 40,
        "label": "Data Storage / Backup / Recovery",
        "selected": 0,
        "collapse": 0,
        "parent": 15,
        "children": [],
        "tooltip": "Solutions that store data securely and restore it in case of loss or system failure."
      },
      {
        "id": 41,
        "label": "Supply Chain Management",
        "selected": 0,
        "collapse": 0,
        "parent": 15,
        "children": [],
        "tooltip": "Tools and processes that manage the flow of goods from production to customer delivery."
      },
      {
        "id": 42,
        "label": "Cloud Transformation / Computing Services",
        "selected": 0,
        "collapse": 0,
        "parent": 15,
        "children": [],
        "tooltip": "Migration of business systems to cloud platforms for scalability and cost efficiency."
      },
      {
        "id": 43,
        "label": "Essential Services",
        "selected": 0,
        "collapse": 0,
        "parent": 15,
        "children": [],
        "tooltip": "Core operational tools and utilities required to keep a business running."
      },
      {
        "id": 44,
        "label": "Networking",
        "selected": 0,
        "collapse": 0,
        "parent": 15,
        "children": [],
        "tooltip": "Hardware and software that connect devices, servers, and systems across a business environment."
      },
      {
        "id": 45,
        "label": "SD-WAN",
        "selected": 0,
        "collapse": 0,
        "parent": 15,
        "children": [],
        "tooltip": "A software defined network system that optimizes routing and connectivity across multiple business locations."
      },
      {
        "id": 46,
        "label": "Career Advancement Courses",
        "selected": 0,
        "collapse": 0,
        "parent": 16,
        "children": [],
        "tooltip": "Training programs that help employees grow skills and advance in their roles."
      },
      {
        "id": 47,
        "label": "Financial Services",
        "selected": 0,
        "collapse": 0,
        "parent": 16,
        "children": [],
        "tooltip": "Business offerings related to payments, banking, budgeting, and financial planning."
      },
      {
        "id": 48,
        "label": "CRM Database Software",
        "selected": 0,
        "collapse": 0,
        "parent": 16,
        "children": [],
        "tooltip": "Tools that store customer information and manage sales, marketing, and service interactions."
      },
      {
        "id": 49,
        "label": "Digital Analytics Software",
        "selected": 0,
        "collapse": 0,
        "parent": 16,
        "children": [],
        "tooltip": "Platforms that analyze online behavior, traffic, and performance data."
      },
      {
        "id": 50,
        "label": "Business Advisory Services",
        "selected": 0,
        "collapse": 0,
        "parent": 16,
        "children": [],
        "tooltip": "Professional guidance that helps organizations improve operations, strategy, and growth."
      },
      {
        "id": 51,
        "label": "Consulting Services",
        "selected": 0,
        "collapse": 0,
        "parent": 16,
        "children": [],
        "tooltip": "Expert support for solving specific business challenges or optimizing processes."
      },
      {
        "id": 52,
        "label": "Online Communication / Collaboration Platform",
        "selected": 0,
        "collapse": 0,
        "parent": 16,
        "children": [],
        "tooltip": "Digital tools that allow teams to message, share files, and work together remotely."
      },
      {
        "id": 53,
        "label": "Artificial Intelligence",
        "selected": 0,
        "collapse": 0,
        "parent": 16,
        "children": [],
        "tooltip": "Technology that uses machine learning to automate tasks, make predictions, and enhance decision making."
      },
      {
        "id": 54,
        "label": "Awards / Accolades",
        "selected": 0,
        "collapse": 0,
        "parent": 17,
        "children": [],
        "tooltip": "Recognitions that highlight a company\u2019s achievements or excellence."
      },
      {
        "id": 55,
        "label": "Brand / Reputation",
        "selected": 0,
        "collapse": 0,
        "parent": 17,
        "children": [],
        "tooltip": "The public perception and identity of a business."
      },
      {
        "id": 56,
        "label": "Product Superiority",
        "selected": 0,
        "collapse": 0,
        "parent": 17,
        "children": [],
        "tooltip": "A value claim emphasizing that a product performs better than competitors\u2019."
      },
      {
        "id": 57,
        "label": "Customer Service",
        "selected": 0,
        "collapse": 0,
        "parent": 17,
        "children": [],
        "tooltip": "Support provided to customers before, during, and after using a product or service."
      },
      {
        "id": 58,
        "label": "Sponsorship / Partnership",
        "selected": 0,
        "collapse": 0,
        "parent": 17,
        "children": [],
        "tooltip": "Collaborations where a brand supports or teams up with another organization."
      },
      {
        "id": 59,
        "label": "Charitable Work / Giving",
        "selected": 0,
        "collapse": 0,
        "parent": 17,
        "children": [],
        "tooltip": "Corporate social responsibility initiatives that support communities or causes."
      },
      {
        "id": 60,
        "label": "Free Equipment / Service",
        "selected": 0,
        "collapse": 0,
        "parent": 18,
        "children": [],
        "tooltip": "An added benefit where hardware or service is included at no charge."
      },
      {
        "id": 61,
        "label": "Price Lock",
        "selected": 0,
        "collapse": 0,
        "parent": 18,
        "children": [],
        "tooltip": "A guarantee that pricing will remain fixed for a set period."
      },
      {
        "id": 62,
        "label": "Limited Time / Special Discount",
        "selected": 0,
        "collapse": 0,
        "parent": 18,
        "children": [],
        "tooltip": "A temporary promotional price or offer."
      },
      {
        "id": 63,
        "label": "Gift Card / Other Incentive",
        "selected": 0,
        "collapse": 0,
        "parent": 18,
        "children": [],
        "tooltip": "A bonus reward provided with purchase or subscription."
      },
      {
        "id": 64,
        "label": "Free Trial / Money Back Guarantee",
        "selected": 0,
        "collapse": 0,
        "parent": 18,
        "children": [],
        "tooltip": "A no cost period allowing customers to test a service before committing."
      },
      {
        "id": 65,
        "label": "Offer Led",
        "selected": 0,
        "collapse": 0,
        "parent": 18,
        "children": [],
        "tooltip": "Marketing that highlights a promotion or discount as the central message."
      },
      {
        "id": 66,
        "label": "Competitive",
        "selected": 0,
        "collapse": 0,
        "parent": 18,
        "children": [],
        "tooltip": "A message focused on outperforming or comparing favorably to competitors."
      },
      {
        "id": 67,
        "label": "Live Action",
        "selected": 0,
        "collapse": 0,
        "parent": 19,
        "children": [],
        "tooltip": "Video content featuring real-world footage and people."
      },
      {
        "id": 68,
        "label": "Focus Group",
        "selected": 0,
        "collapse": 0,
        "parent": 19,
        "children": [],
        "tooltip": "Content based on customer discussions or feedback sessions."
      },
      {
        "id": 69,
        "label": "Animated",
        "selected": 0,
        "collapse": 0,
        "parent": 19,
        "children": [],
        "tooltip": "Content using motion graphics or cartoon style visuals."
      },
      {
        "id": 70,
        "label": "Graphic",
        "selected": 0,
        "collapse": 0,
        "parent": 19,
        "children": [],
        "tooltip": "Static or stylized visual content, such as infographics or illustrations."
      },
      {
        "id": 71,
        "label": "Product Demo",
        "selected": 0,
        "collapse": 0,
        "parent": 19,
        "children": [],
        "tooltip": "A demonstration showing how a product or service works."
      },
      {
        "id": 72,
        "label": "Emotional",
        "selected": 0,
        "collapse": 0,
        "parent": 20,
        "children": [],
        "tooltip": "Storytelling that appeals to audience feelings or values."
      },
      {
        "id": 73,
        "label": "Spokesperson",
        "selected": 0,
        "collapse": 0,
        "parent": 20,
        "children": [],
        "tooltip": "A message delivered by a designated representative of a brand."
      },
      {
        "id": 74,
        "label": "Celebrity",
        "selected": 0,
        "collapse": 0,
        "parent": 20,
        "children": [],
        "tooltip": "Advertising featuring a well known public figure."
      },
      {
        "id": 75,
        "label": "Real Business Owners",
        "selected": 0,
        "collapse": 0,
        "parent": 20,
        "children": [],
        "tooltip": "Testimonials or stories shared by actual customers who own businesses."
      },
      {
        "id": 76,
        "label": "Real Employees",
        "selected": 0,
        "collapse": 0,
        "parent": 20,
        "children": [],
        "tooltip": "Content featuring actual staff members of the company."
      },
      {
        "id": 77,
        "label": "Testimonial",
        "selected": 0,
        "collapse": 0,
        "parent": 20,
        "children": [],
        "tooltip": "A customer sharing their positive experience with a product or service."
      },
      {
        "id": 78,
        "label": "Case Study",
        "selected": 0,
        "collapse": 0,
        "parent": 20,
        "children": [],
        "tooltip": "A detailed example showing how a business problem was solved using a product or service."
      },
      {
        "id": 79,
        "label": "Diversity / Inclusivity Elements",
        "selected": 0,
        "collapse": 0,
        "parent": 20,
        "children": [],
        "tooltip": "Content that represents a variety of backgrounds, identities, and perspectives."
      }
    ]
  }
};


// WEBPACK FOOTER //
// ./src/app/configuration/Optimum/config/components/selection/Search/tagHierarchy.js